import React from 'react'
import ReactDOM from 'react-dom/client'
import './style.css'
import './styles/sidebar.css'
import './styles/ghost-content.css'
import { App } from './App'
// Globale Utility-Funktionen fuer script.js exponieren
import './lib/captureViewerThumbnail'

ReactDOM.createRoot(document.getElementById('react-root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
